<template>
  <div class="modal-card">
    <header class="modal-header">
      <p class="modal-card-title">
        Suppression d'une configuration
      </p>
    </header>
    <section class="modal-card-body">
      {{ message }}
    </section>
    <footer class="modal-card-foot justify-end">
      <b-button
        type="is-primary"
        @click="$parent.close()"
      >
        Annuler
      </b-button>
      <b-button
        type="is-danger"
        @click="$emit('confirm') ; $parent.close();"
      >
        {{ dangerButtonText }}
      </b-button>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'BaseConfirmModal',
  props: {
    message: {
      type: String,
      required: true,
    },
    dangerButtonText: {
      type: String,
      default: 'Supprimer',
    },
  },
};
</script>
